exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.preloader.is-absolute {\r\n  position: absolute;\n}\r\n", ""]);

// exports
